import { Navigate } from 'react-router';

import { useGetQaAttempt } from '../../hooks/api/schema-hooks/useGetQaAttempt.ts';
import { useToaster } from '../../hooks/useToaster/useToaster.tsx';
import { QABetaModule } from '../../modules/qaBeta/QABetaModule.tsx';
import { featuresSelectors } from '../../redux/features/selectors/featuresSelectors.ts';
import { selectOrder } from '../../redux/features/selectors/orderSelectors.ts';
import { selectSubjectAddressDisplay } from '../../redux/features/selectors/selectSubjectAddressDisplay.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useStartQA } from '../hooks/useStartQA.ts';

const { selectShouldShowOffshoreQCBeta } = featuresSelectors;

export const QARouteElement = () => {
  const { id: orderID } = useAppSelector(selectOrder);
  const address = useAppSelector(selectSubjectAddressDisplay);

  const toast = useToaster();
  const shouldShowQCModule = useAppSelector(selectShouldShowOffshoreQCBeta);
  const { data, isLoading, isError, refetch } = useGetQaAttempt(
    { pathParams: { orderID } },
    { enabled: shouldShowQCModule, meta: { showGlobalLoader: true } },
  );

  const startQAMutation = useStartQA({
    onSettled: () => {
      // In the future we can use invalidate queries but
      // RQ has a few hang ups when using it in parallel to the
      // enabled flag: https://stackoverflow.com/questions/68577988/invalidate-queries-doesnt-work-react-query
      // queryClient.invalidateQueries({ queryKey });

      refetch().catch(console.error);
    },
    onSuccess: () => {
      toast({
        id: `${orderID}-submit-qa-success`,
        type: 'success',
        title: 'Sent to QC',
        body: 'Your appraisal has been sent to quality control and you will receive an email once review results are ready.',
      });
    },
    onError: () => {
      toast({
        id: `${orderID}-submit-qa-error`,
        type: 'error',
        title: 'Error Submitting QC Documents',
        body: 'There was an error submitting your documents to QC. Please ensure you have uploaded the correct documents and try again.',
      });
    },
  });

  if (!shouldShowQCModule) return <Navigate to="/orders" />;

  if (isLoading || isError || !data) return null;

  return <QABetaModule address={address} qaAttempt={data} startQAMutation={startQAMutation} />;
};
